import * as React from 'react';
import { useSelector } from 'react-redux';

import { ChatHeaderCard } from '../../components/ChatHeader';
import { selectChatHeaderCard } from '../../selectors/chatHeaderCardSelector';

export const ChatHeaderCardPreviewContainer = () => {
  const headerCard = useSelector(selectChatHeaderCard);

  if (!headerCard) {
    return null;
  }

  return <ChatHeaderCard {...headerCard} />;
};
